import { render, staticRenderFns } from "./Jumpnav.vue?vue&type=template&id=28ef077b&scoped=true&"
import script from "./Jumpnav.vue?vue&type=script&lang=js&"
export * from "./Jumpnav.vue?vue&type=script&lang=js&"
import style0 from "./Jumpnav.vue?vue&type=style&index=0&id=28ef077b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef077b",
  null
  
)

export default component.exports